import { GlobalConstants } from "../constant/constant";
import { Coordinate, LocationCaptureMethod, LocationComponentValue, PostitionCoords } from "../models/location/location-models";

export function hasValidCoordinates(coordinate?: Pick<Coordinate, 'latitude' | 'longitude'> | null): boolean {
  return Number.isFinite(coordinate?.latitude) &&
    Math.abs(coordinate.latitude) <= 90 &&
    Number.isFinite(coordinate?.longitude) &&
    Math.abs(coordinate.longitude) <= 180;
}

export function isUnavailableLocation(value?: LocationComponentValue | null): boolean {
  return value?.unavailable === true &&
    Array.isArray(value.coordinates) && value.coordinates.length === 0;
}

export function convertAccuracyInMetersToFeet(accuracy: number) {
  return Math.round(accuracy * GlobalConstants.METER_TO_FOOT_CONVERSION_RATE);
}

export function getFormattedCoordinate(coords: PostitionCoords, captureMethod: LocationCaptureMethod): Coordinate {
    return {
      latitude: +coords.latitude.toFixed(GlobalConstants.COORDINATES_PRECISION),
      longitude: +coords.longitude.toFixed(GlobalConstants.COORDINATES_PRECISION),
      accuracy: coords.accuracy ? convertAccuracyInMetersToFeet(coords.accuracy) : null,
      altitude: coords.altitude ? +coords.altitude.toFixed(GlobalConstants.COORDINATES_PRECISION) : null,
      datetime: new Date().toISOString(),
      captureMethod: captureMethod
    };
  }